import { render } from "./NotFound.vue?vue&type=template&id=ce611fa0&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=ce611fa0&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce611fa0"]])

export default __exports__